// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This replaces BasePublic class with a factory function that uses BaseApiServiceFactory

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";
import { ContentType } from "@Front/Api/ContentType";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

export interface IBasePublic extends IBaseApiService {
	namespaceUrl: string;
}

export function createBasePublic(): IBasePublic {
	const baseApi = createBaseApiService();

	// Override buildHeaders to not include Authorization for public endpoints
	const buildHeaders = (contentType: ContentType): Headers => {
		const headers = new Headers();
		if (contentType === ContentType.JSON || contentType === ContentType.PDF) {
			headers.set("Content-Type", contentType);
		}
		return headers;
	};

	// Override onError to use LoggerService
	const onError = (error: unknown): void => {
		LoggerService.error("❌ [BasePublic] Public request failed", { error });
	};

	return {
		...baseApi,
		buildHeaders,
		onError,
		get namespaceUrl(): string {
			return baseApi.getBaseUrl().concat("/public");
		},
	};
}
